import { render } from "./ComputerInfor.vue?vue&type=template&id=24510656"
const script = {}

import "./ComputerInfor.vue?vue&type=style&index=0&id=24510656&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__